module.exports = __webpack_public_path__ + "img/s7Model3.cc7da8dc.webp";